import React from "react";
import styled from "styled-components";
import * as Datetime from "react-datetime";
const moment = require("moment");
moment().format();

import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";

const Input = styled.input`
  margin: 0 0.25rem 0 0.25rem;
  font-size: 1rem;
  border: 1px solid;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-clip: padding-box;
  outline: none;
  padding: 0.2rem;
  width: 50px;
`;

const DatePickerRow = styled.div`
  margin: 8 0 8 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
const CheckBox = styled.input`
  margin-right: 4px;
`;

const CheckBoxLabel = styled.label`
  margin: 8 0 8 0;
`;

const FormRow = styled.div`
  margin: 8 0 8 0;
`;

export default class IndexCallReservation extends React.Component {
  render() {
    let {
      lengthLower,
      lengthUpper,
      AMRLower,
      AMRUpper,
      isASAP,
      timeWindowLower,
      timeWindowUpper,
      claimsAvailable,
      onChange,
      onTimeWindowChange,
      onSubmit,
      onCancel,
      reserving,
      data,
    } = this.props;

    let pendingReservations = data.pending_reservations || [];

    return (
      <Card body>
        <h1 className="large">Reserve or Claim a Call</h1>
        <p>Number of claims available: {claimsAvailable}</p>
        {pendingReservations.length === 0 ? (
          <>
            <p>
              Enter the characteristics of the call you would like to
              transcribe! Less specific requests are more likely to be
              successful!
            </p>
            <FormRow>
              <label>
                Transcription Length (in minutes):
                <Input
                  value={lengthLower}
                  type="number"
                  min="0"
                  name="lengthLower"
                  onChange={onChange}
                />
                to
                <Input
                  value={lengthUpper}
                  type="number"
                  min="0"
                  name="lengthUpper"
                  onChange={onChange}
                />
              </label>
            </FormRow>
            <FormRow>
              <label>
                Desired Audio Minute Rate: $
                <Input
                  value={AMRLower}
                  step={0.01}
                  type="number"
                  min="0"
                  name="AMRLower"
                  onChange={onChange}
                />
                to $
                <Input
                  value={AMRUpper}
                  step={0.01}
                  type="number"
                  min="0"
                  name="AMRUpper"
                  onChange={onChange}
                />
              </label>
            </FormRow>
            <FormRow>
              <CheckBoxLabel>
                <CheckBox
                  type="checkbox"
                  name="isASAP"
                  checked={isASAP}
                  onChange={onChange}
                />
                Pull a call for me now
              </CheckBoxLabel>
            </FormRow>
            {!isASAP && (
              <DatePickerRow>
                <span>
                  <p>Time Lower</p>
                  <Datetime
                    className="timeWindowLower"
                    value={timeWindowLower}
                    input={false}
                    onChange={m => onTimeWindowChange("timeWindowLower", m)}
                  />
                </span>
                <span>
                  <p>Time Upper</p>
                  <Datetime
                    className="timeWindowUpper"
                    value={timeWindowUpper}
                    input={false}
                    onChange={m => onTimeWindowChange("timeWindowUpper", m)}
                  />
                </span>
              </DatePickerRow>
            )}
            <FormRow>
              <Button type="primary" onClick={onSubmit} disabled={reserving}>
                {reserving && (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
                <span>{reserving ? "" : "Submit Request"}</span>
              </Button>
            </FormRow>
          </>
        ) : (
          <>
            <p>Thank you for your request! We are searching for your call.</p>
            <p>Your Request:</p>
            <p>
              Estimated Audio for Transcription (min):{" "}
              {pendingReservations[0].call_length_seconds_min / 60} -{" "}
              {pendingReservations[0].call_length_seconds_max / 60}
            </p>
            <p>
              Price: ${pendingReservations[0].audio_minute_dollars_rate_min} - $
              {pendingReservations[0].audio_minute_dollars_rate_max}
            </p>
            <p>
              Reservation Time:{" "}
              {moment
                .utc(pendingReservations[0].datetime_seek_min)
                .local()
                .format("dddd, MMMM Do, h:mmA")}{" "}
              -{" "}
              {moment
                .utc(pendingReservations[0].datetime_seek_max)
                .local()
                .format("dddd, MMMM Do, h:mmA")}
            </p>
            <p>
              If you’ve changed your mind about this request, please click
              cancel request below to change or cancel.
            </p>
            <p>
              Once a call has been reserved it will count as one of your daily
              claims and you will only have 30 minutes to begin working on it
              before it is released!
            </p>
            <Button variant="danger" onClick={onCancel}>
              Cancel Request
            </Button>
          </>
        )}
      </Card>
    );
  }
}
